import React from 'react'

const WalletPage = () => {
  return (
    <div>Coming soon...</div>
  )
}

export default WalletPage